<template>
  <modal class="previews-modal" :show.sync="showModal" modalContentClasses="previews-modal-content" bodyClasses="previews-modal-body">
    <div class="scroll-container h-100" ref="scrollContainer">
      <base-button type="danger" class="previews-close-top" round @click="handleClose()"><i class="fas fa-times"></i></base-button>
        <div class="type-buttons">
          <base-button class="mb-2 spotify-btn" type="primary" @click="setType('spotify')"><i class="fab fa-spotify"></i></base-button>
          <base-button class="mb-2 apple-btn" type="primary" @click="setType('applemusic')"><i class="fab fa-apple"></i></base-button>
          <base-button class="mb-2 soundcloud-btn" type="primary" @click="setType('soundcloud')"><i class="fab fa-soundcloud"></i></base-button>
          <base-button class="mb-2 bandcamp-btn" type="primary" @click="setType('bandcamp')"><i class="fab fa-bandcamp"></i></base-button>
        </div>
        <div class="previews-scroll-top"></div>
        <div class="preview-warning d-sm-block d-md-none">Some previews may be best viewed on a laptop/desktop computer.</div>
        <div class="previews-scroll-wrapper" :style="{maxHeight: scrollMaxHeight ? scrollMaxHeight +'px' : '100%'}">
          <div v-if="previewType === 'spotify'" class="spotify-web-mockup-wrapper" :style="{width: spotifyWebScale * 1539 + 'px', height: spotifyWebScale * 1189 + 'px', transform: 'scale(' + spotifyWebScale + ')'}">
            <div class="spotify-web-background" :style="{backgroundImage: 'url(/img/mockups/spotify-web.png)'}">
              <div class="spotify-web-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="spotify-web-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="spotify-web-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="spotify-web-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>  
          </div>
          <div v-if="previewType === 'spotify'" class="spotify-mobile-album-mockup-wrapper" :style="{width: spotifyMobileAlbumScale * 460 + 'px', height: spotifyMobileAlbumScale * 949 + 'px',transform: 'scale(' + spotifyMobileAlbumScale + ')'}">
            <div class="spotify-mobile-album-background" :style="{backgroundImage: 'url(/img/mockups/spotify-mobile-album.png)'}">
              <div class="spotify-mobile-album-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="spotify-mobile-album-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>
          </div>
          <div v-if="previewType === 'soundcloud'" class="soundcloud-web-mockup-wrapper" :style="{width: soundcloudWebScale * 1539 + 'px', height: soundcloudWebScale * 1189 + 'px', transform: 'scale(' + soundcloudWebScale + ')'}">
            <div class="soundcloud-web-background" :style="{backgroundImage: 'url(/img/mockups/soundcloud-web.png)'}">
              <div class="soundcloud-web-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-web-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-web-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-web-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-web-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-web-image-6 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-web-image-7 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>  
          </div>
          <div v-if="previewType === 'soundcloud'" class="soundcloud-mobile-album-mockup-wrapper" :style="{width: soundcloudMobileScale * 460 + 'px', height: soundcloudMobileScale * 949 + 'px',transform: 'scale(' + soundcloudMobileScale + ')'}">
            <div class="soundcloud-mobile-album-background" :style="{backgroundImage: 'url(/img/mockups/soundcloud-mobile-light.png)'}">
              <div class="soundcloud-mobile-album-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-mobile-album-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>
          </div>
          <div v-if="previewType === 'soundcloud'" class="soundcloud-mobile-album-mockup-wrapper" :style="{width: soundcloudMobileScale * 460 + 'px', height: soundcloudMobileScale * 949 + 'px',transform: 'scale(' + soundcloudMobileScale + ')'}">
            <div class="soundcloud-mobile-album-background" :style="{backgroundImage: 'url(/img/mockups/soundcloud-mobile-dark.png)'}">
              <div class="soundcloud-mobile-album-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-mobile-album-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="soundcloud-mobile-album-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>
          </div>
          <div v-if="previewType === 'applemusic'" class="applemusic-desktop-mockup-wrapper" :style="{width: applemusicDesktopScale * 1539 + 'px', height: applemusicDesktopScale * 1189 + 'px', transform: 'scale(' + applemusicDesktopScale + ')'}">
            <div class="applemusic-desktop-background" :style="{backgroundImage: 'url(/img/mockups/apple-music-desktop-light.png)'}">
              <div class="applemusic-desktop-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>  
          </div>
          <div v-if="previewType === 'applemusic'" class="applemusic-desktop-mockup-wrapper" :style="{width: applemusicDesktopScale * 1539 + 'px', height: applemusicDesktopScale * 1189 + 'px', transform: 'scale(' + applemusicDesktopScale + ')'}">
            <div class="applemusic-desktop-background" :style="{backgroundImage: 'url(/img/mockups/apple-music-desktop-dark.png)'}">
              <div class="applemusic-desktop-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-desktop-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>  
          </div>
          <div v-if="previewType === 'applemusic'" class="applemusic-mobile-mockup-wrapper" :style="{width: applemusicMobileScale * 460 + 'px', height: applemusicMobileScale * 949 + 'px', transform: 'scale(' + applemusicMobileScale + ')'}">
            <div class="applemusic-mobile-background" :style="{backgroundImage: 'url(/img/mockups/apple-music-mobile-light.png)'}">
              <div class="applemusic-mobile-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-mobile-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-mobile-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>  
          </div>
          <div v-if="previewType === 'applemusic'" class="applemusic-mobile-mockup-wrapper" :style="{width: applemusicMobileScale * 460 + 'px', height: applemusicMobileScale * 949 + 'px', transform: 'scale(' + applemusicMobileScale + ')'}">
            <div class="applemusic-mobile-background" :style="{backgroundImage: 'url(/img/mockups/apple-music-mobile-dark.png)'}">
              <div class="applemusic-mobile-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
              <div class="applemusic-mobile-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            </div>  
          </div>
        </div>
        <div v-if="previewType === 'bandcamp'" class="bandcamp-desktop-mockup-wrapper" :style="{width: bandcampDesktopScale * 1539 + 'px', height: bandcampDesktopScale * 1189 + 'px', transform: 'scale(' + bandcampDesktopScale + ')'}">
          <div class="bandcamp-desktop-background" :style="{backgroundImage: 'url(/img/mockups/bandcamp-desktop-mockup.png)'}">
            <div class="bandcamp-desktop-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-6 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-7 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-8 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-9 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-10 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-11 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-desktop-image-12 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
          </div>  
        </div>
        <div v-if="previewType === 'bandcamp'" class="bandcamp-mobile-mockup-wrapper" :style="{width: bandcampMobileScale * 460 + 'px', height: bandcampMobileScale * 949 + 'px', transform: 'scale(' + bandcampMobileScale + ')'}">
          <div class="bandcamp-mobile-background" :style="{backgroundImage: 'url(/img/mockups/bandcamp-mobile-albums.png)'}">
            <div class="bandcamp-mobile-image-1 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-mobile-image-2 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
          </div>  
        </div>
        <div v-if="previewType === 'bandcamp'" class="bandcamp-mobile-mockup-wrapper" :style="{width: bandcampMobileScale * 460 + 'px', height: bandcampMobileScale * 949 + 'px', transform: 'scale(' + bandcampMobileScale + ')'}">
          <div class="bandcamp-mobile-background" :style="{backgroundImage: 'url(/img/mockups/bandcamp-mobile-feed.png)'}">
            <div class="bandcamp-mobile-image-3 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-mobile-image-4 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
            <div class="bandcamp-mobile-image-5 album-art-crop" :style="{backgroundImage: 'url(' + previewImage + ')'}"></div>
          </div>  
        </div>
        <base-button type="danger" class="previews-close mb-5" size="sm" @click="handleClose()"><i class="fas fa-times"></i> Close</base-button>
    </div>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import BaseButton from '../../../myportal-artgrab-co/src/components/BaseButton.vue';

export default {
  components: { BaseButton },
  name: "previews-modal",
  data() {
    return {
      spotifyWebScale: 0,
      spotifyMobileScale: 0,
      spotifyMobileAlbumScale: 0,
      soundcloudWebScale: 0,
      soundcloudMobileScale: 0,
      applemusicDesktopScale: 0,
      applemusicMobileScale: 0,
      bandcampDesktopScale: 0,
      bandcampMobileScale: 0,
      scrollMaxHeight: 0
    };
  },
  computed: {
    ...mapState(["user", "previewImage", "previewType"]),
    showModal: {
      get() {
        return this.$store.state.showPreviewsModal;
      },
      set() {
        this.$store.commit("showPreviewsModal", false);
      }
    }
  },
  methods: {
    handleClose() {
      this.$refs.scrollContainer.scrollTop = 0;
      this.$store.commit("showPreviewsModal", false);
      this.$store.commit("setPreviewImage", "");
      this.$store.commit("setPreviewType", "spotify");
    },
    setType(type) {
      this.$store.commit("setPreviewType", type);
    },
    getDimensions() {
      const body = document.body;
      const html = document.documentElement;
      const height = Math.max( body.scrollHeight, body.offsetHeight, 
                       html.clientHeight, html.scrollHeight, html.offsetHeight );
      if (this.previewType === 'spotify') {
        const spotifyWebScaleLocal = Math.min( document.documentElement.clientWidth / 1539, height / 1189 );
        this.spotifyWebScale = spotifyWebScaleLocal > 1 ? 1 : spotifyWebScaleLocal;
        const spotifyMobileAlbumScaleLocal = Math.min( document.documentElement.clientWidth / 460, height / 949 );
        this.spotifyMobileAlbumScale = spotifyMobileAlbumScaleLocal > 1 ? 1 : spotifyMobileAlbumScaleLocal;
        this.scrollMaxHeight = (1189 * this.spotifyWebScale) + (949 * this.spotifyMobileAlbumScale);
      }
      if (this.previewType === 'soundcloud') {
        const soundcloudWebScaleLocal = Math.min( document.documentElement.clientWidth / 1539, height / 1189 );
        this.soundcloudWebScale = soundcloudWebScaleLocal > 1 ? 1 : soundcloudWebScaleLocal;
        const soundcloudMobileScaleLocal = Math.min( document.documentElement.clientWidth / 460, height / 949 );
        this.soundcloudMobileScale = soundcloudMobileScaleLocal > 1 ? 1 : soundcloudMobileScaleLocal;
        this.scrollMaxHeight = (1189 * this.soundcloudWebScale) + (949 * this.soundcloudMobileScale) + (949 * this.soundcloudMobileScale);
      }
      if (this.previewType === 'applemusic') {
        const applemusicDesktopScaleLocal = Math.min( document.documentElement.clientWidth / 1539, height / 1189 );
        this.applemusicDesktopScale = applemusicDesktopScaleLocal > 1 ? 1 : applemusicDesktopScaleLocal;
        const applemusicMobileScaleLocal = Math.min( document.documentElement.clientWidth / 460, height / 949 );
        this.applemusicMobileScale = applemusicMobileScaleLocal > 1 ? 1 : applemusicMobileScaleLocal;
        this.scrollMaxHeight = (1189 * this.applemusicDesktopScale) + (1189 * this.applemusicDesktopScale) + (949 * this.applemusicMobileScale) + (949 * this.applemusicMobileScale);
      }
      if (this.previewType === 'bandcamp') {
        const bandcampDesktopScaleLocal = Math.min( document.documentElement.clientWidth / 1539, height / 1189 );
        this.bandcampDesktopScale = bandcampDesktopScaleLocal > 1 ? 1 : bandcampDesktopScaleLocal;
        const bandcampMobileScaleLocal = Math.min( document.documentElement.clientWidth / 460, height / 949 );
        this.bandcampMobileScale = bandcampMobileScaleLocal > 1 ? 1 : bandcampMobileScaleLocal;
        this.scrollMaxHeight = (1189 * this.bandcampDesktopScale) + (949 * this.bandcampMobileScale) + (949 * this.bandcampMobileScale);
      }
    }
  },
  mounted() {
    this.getDimensions();
    window.addEventListener('resize', this.getDimensions);
  },
  unmounted() {
    window.removeEventListener('resize', this.getDimensions);
  },
  watch: {
    previewType() {
      this.getDimensions();
    }
  }
};
</script>

<style lang="scss">
.previews-modal {
  text-align: center;

  &.modal.show {
    background-color: rgba(0, 0, 0, 0.90);
  }

  .preview-warning {
    background: black;
    color: white;
    padding: 10px;
    text-align: center;
    border-radius: 8px;
    font-size: 0.875rem;
    margin: 80px 15px 10px;
  }

  .previews-close {
    margin-top: 30px;
  }

  .previews-close-top {
    position: fixed;
    top: 20px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    z-index: 20;
  }

  .modal-dialog {
    max-width: 100%;
    width: 100%;
    margin: 0;
  }

  .modal-header {
    .close {
      span {
        font-size: 3rem;
      }
    }
  }

  .type-buttons {
    position: absolute;
    top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 1;

    button {
      padding: 10px 8px;
      border: none;
      width: 40px;
    }

    .spotify-btn {
      color: #1DB954;

      &:active, &:focus {
        color: #1DB954;
      }
    }

    .apple-btn {
      color: #fc3c44;

      &:active, &:focus {
        color: #fc3c44;
      }
    }

    .soundcloud-btn {
      color: #ff7700;

      &:active, &:focus {
        color: #ff7700;
      }
    }

    .bandcamp-btn {
      color: #629aa9;

      &:active, &:focus {
        color: #629aa9;
      }
    }
  }

  .previews-modal-content {
    overflow: hidden;
    border-radius: 0;
    background-color: transparent;

    .album-art-crop {
      overflow: hidden;
      background-size: cover;
      background-position: center;
    }

    .previews-scroll-wrapper {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-width: 100vw;
    }

    // Spotify
    .spotify-web-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;
      padding-top: 20px;

      .spotify-web-background {
        width: 1539px;
        height: 1189px;
        margin: 0 auto;
        position: relative;
      }

      .spotify-web-image-1 {
        position: absolute;
        top: 827.5px;
        left: 59px;
        width: 242px;
        height: 242px;
      }

      .spotify-web-image-2 {
        position: absolute;
        top: 303.5px;
        left: 381.5px;
        width: 41px;
        height: 41px;
      }

      .spotify-web-image-3 {
        position: absolute;
        top: 785px;
        left: 348px;
        width: 175px;
        height: 175px;
        border-radius: 3px;
      }

      .spotify-web-image-4 {
        position: absolute;
        top: 294px;
        left: 1019.5px;
        width: 78px;
        height: 78px;
      }
    }

    .spotify-mobile-album-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;

      .spotify-mobile-album-background {
        width: 460px;
        height: 949px;
        margin: 0 auto;
        position: relative;
      }

      .spotify-mobile-album-image-1 {
        position: absolute;
        top: 82px;
        left: 89px;
        width: 281px;
        height: 281px;
      }

      .spotify-mobile-album-image-2 {
        position: absolute;
        top: 787px;
        left: 36px;
        width: 41px;
        height: 41px;
        border-radius: 4px;
      }
    }

    // SoundCloud
    .soundcloud-web-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;
      padding-top: 64px;

      .soundcloud-web-background {
        width: 1539px;
        height: 1189px;
        margin: 0 auto;
        position: relative;
      }

      .soundcloud-web-image-1 {
        position: absolute;
        top: 221px;
        left: 180px;
        width: 174px;
        height: 174px;
      }

      .soundcloud-web-image-2 {
        position: absolute;
        top: 221px;
        left: 759px;
        width: 174px;
        height: 174px;
        border-radius: 87px;
      }

      .soundcloud-web-image-3 {
        position: absolute;
        top: 621px;
        left: 197px;
        width: 178px;
        height: 178px;
      }

      .soundcloud-web-image-4 {
        position: absolute;
        top: 836px;
        left: 246px;
        width: 38px;
        height: 38px;
        border: 2px solid white;
        border-radius: 50px;
      }

      .soundcloud-web-image-5 {
        position: absolute;
        top: 351px;
        left: 1060px;
        width: 50px;
        height: 50px;
        border-radius: 50px;
      }

      .soundcloud-web-image-6 {
        position: absolute;
        top: 614px;
        left: 1060px;
        width: 50px;
        height: 50px;
      }

      .soundcloud-web-image-7 {
        position: absolute;
        top: 1074px;
        left: 1036px;
        width: 34px;
        height: 34px;
      }
    }

    .soundcloud-mobile-album-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;

      .soundcloud-mobile-album-background {
        width: 460px;
        height: 949px;
        margin: 0 auto;
        position: relative;
      }

      .soundcloud-mobile-album-image-1 {
        position: absolute;
        top: 180px;
        left: 36px;
        width: 131px;
        height: 131px;
      }

      .soundcloud-mobile-album-image-2 {
        position: absolute;
        top: 503px;
        left: 36px;
        width: 62px;
        height: 62px;
      }

      .soundcloud-mobile-album-image-3 {
        position: absolute;
        top: 110px;
        left: 20px;
        width: 421px;
        height: 421px;
      }

      .soundcloud-mobile-album-image-4 {
        position: absolute;
        top: 600px;
        left: 36px;
        width: 64px;
        height: 64px;
      }

      .soundcloud-mobile-album-image-5 {
        position: absolute;
        top: 705px;
        left: 36px;
        width: 64px;
        height: 64px;
      }
    }

    // Apple Music
    .applemusic-desktop-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;
      padding-top: 64px;

      .applemusic-desktop-background {
        width: 1539px;
        height: 1189px;
        margin: 0 auto;
        position: relative;
      }

      .applemusic-desktop-image-1 {
        position: absolute;
        top: 197px;
        left: 317px;
        width: 165px;
        height: 165px;
        border-radius: 4px;
      }

      .applemusic-desktop-image-2 {
        position: absolute;
        top: 443px;
        left: 317px;
        width: 269px;
        height: 269px;
        border-radius: 6px;
      }

      .applemusic-desktop-image-3 {
        position: absolute;
        top: 825px;
        left: 317px;
        width: 212px;
        height: 212px;
        border-radius: 4px;
      }

      .applemusic-desktop-image-4 {
        position: absolute;
        top: 204px;
        left: 1120px;
        width: 41px;
        height: 41px;
        border-radius: 3px;
      }

      .applemusic-desktop-image-5 {
        position: absolute;
        top: 43px;
        left: 620px;
        width: 42px;
        height: 42px;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }
    }

    .applemusic-mobile-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;

      .applemusic-mobile-background {
        width: 460px;
        height: 949px;
        margin: 0 auto;
        position: relative;
      }

      .applemusic-mobile-image-1 {
        position: absolute;
        top: 117px;
        left: 40px;
        width: 48px;
        height: 48px;
        border-radius: 2px;
      }

      .applemusic-mobile-image-2 {
        position: absolute;
        top: 360px;
        left: 40px;
        width: 380px;
        height: 380px;
        border-radius: 5px;
      }

      .applemusic-mobile-image-3 {
        position: absolute;
        top: 787px;
        left: 40px;
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }

      .applemusic-mobile-image-4 {
        position: absolute;
        top: 119px;
        left: 93px;
        width: 275px;
        height: 275px;
        border-radius: 5px;
      }

      .applemusic-mobile-image-5 {
        position: absolute;
        top: 787px;
        left: 40px;
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }
    }

      // Bandcamp
    .bandcamp-desktop-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;
      padding-top: 64px;

      .bandcamp-desktop-background {
        width: 1539px;
        height: 1189px;
        margin: 0 auto;
        position: relative;
      }

      .bandcamp-desktop-image-1 {
        position: absolute;
        top: 144px;
        left: 282px;
        width: 975px;
        height: 180px;
      }

      .bandcamp-desktop-image-2 {
        position: absolute;
        top: 407px;
        left: 719px;
        width: 350px;
        height: 350px;
      }

      .bandcamp-desktop-image-3 {
        position: absolute;
        top: 407px;
        left: 1107px;
        width: 120px;
        height: 120px;
      }

      .bandcamp-desktop-image-4 {
        position: absolute;
        top: 932px;
        left: 1107px;
        width: 120px;
        height: 120px;
      }

      .bandcamp-desktop-image-5 {
        position: absolute;
        top: 1033px;
        left: 315px;
        width: 39px;
        height: 39px;
      }

      .bandcamp-desktop-image-6 {
        position: absolute;
        top: 749px;
        left: 318px;
        width: 22px;
        height: 22px;
      }

      .bandcamp-desktop-image-7 {
        position: absolute;
        top: 773px;
        left: 324px;
        width: 14px;
        height: 14px;
      }

      .bandcamp-desktop-image-8 {
        position: absolute;
        top: 749px;
        left: 352px;
        width: 20px;
        height: 26px;
      }

      .bandcamp-desktop-image-9 {
        position: absolute;
        top: 778px;
        left: 348px;
        width: 6px;
        height: 6px;
      }

      .bandcamp-desktop-image-10 {
        position: absolute;
        top: 778px;
        left: 356px;
        width: 6px;
        height: 6px;
      }

      .bandcamp-desktop-image-11 {
        position: absolute;
        top: 778px;
        left: 364px;
        width: 6px;
        height: 6px;
      }

      .bandcamp-desktop-image-12 {
        position: absolute;
        top: 945px;
        left: 718px;
        width: 28px;
        height: 28px;
      }
    }

    .bandcamp-mobile-mockup-wrapper {
      position: relative;
      transform-origin: top left;
      margin: 0 auto;

      .bandcamp-mobile-background {
        width: 460px;
        height: 949px;
        margin: 0 auto;
        position: relative;
      }

      .bandcamp-mobile-image-1 {
        position: absolute;
        top: 72px;
        left: 69px;
        width: 42px;
        height: 42px;
        border-radius: 6px;
      }

      .bandcamp-mobile-image-2 {
        position: absolute;
        top: 189px;
        left: 31px;
        width: 191px;
        height: 191px;
      }

      .bandcamp-mobile-image-3 {
        position: absolute;
        top: 156px;
        left: 31px;
        width: 50px;
        height: 50px;
      }

      .bandcamp-mobile-image-4 {
        position: absolute;
        top: 205px;
        left: 31px;
        width: 398px;
        height: 398px;
      }

      .bandcamp-mobile-image-5 {
        position: absolute;
        top: 779px;
        left: 44px;
        width: 50px;
        height: 50px;
      }
    }
  }

  .previews-modal-body {
    // overflow-y: scroll;
    padding: 0;
  }

  .scroll-container {
    overflow-y: scroll;
  }
}
</style>
